'use strict';

/**
 * Created by stapletont on 10/02/2015.
 */

define('polyfill', ['es5Shim'], function () {
  // Polyfill from https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

  // From: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode !== null) this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

  // This is not even standard!!
  if (!Array.prototype.unique) {
    Array.prototype.unique = function () {
      var unique = [];
      for (var i = 0; i < this.length; i++) {
        if (unique.indexOf(this[i]) === -1) {
          unique.push(this[i]);
        }
      }
      return unique;
    };
  }
});
//# sourceMappingURL=polyfill.js.map
